<template>
  <div>
    <informations-generales :contrat="contrat"></informations-generales>
    <contrat :contrat="contrat" class="mgt-20px" :echeancier="echeancier"></contrat>
    <renouvellementBail :contrat="contrat"></renouvellementBail>
    <bailleur :contrat="contrat" class="mgt-20px"></bailleur>
    <informations-financiere :contrat="contrat" class="mgt-20px" :echeancier="echeancier">
    </informations-financiere>
    <echeance :contrat="contrat" class="mgt-20px" :echeancier="echeancier"></echeance>
    <indexation :contrat="contrat" class="mgt-20px"></indexation>
    <contrepartie :contrat="contrat" class="mgt-20px"></contrepartie>
    <commentaire :contrat="contrat" class="mgt-20px"></commentaire>
    <piecesJointes class="mgt-20px"></piecesJointes>
  </div>
</template>

<script>
import informationsGenerales from '@/components/baux/contrat/componentEdition/informationsGenerales';
import contrat from '@/components/baux/contrat/componentEdition/contrat';
import informationsFinanciere from '@/components/baux/contrat/componentEdition/informationsFinanciere';
import echeance from '@/components/baux/contrat/componentEdition/echeance';
import indexation from '@/components/baux/contrat/componentEdition/indexation';
import commentaire from '@/components/baux/contrat/componentEdition/commentaire';
import bailleur from '@/components/baux/contrat/componentEdition/bailleur';
import piecesJointes from '@/components/baux/contrat/componentEdition/pieceJointe';
import contrepartie from '@/components/baux/contrat/contrepartie';
import renouvellementBail from '@/components/baux/contrat/componentEdition/renouvellementBail';

export default {
  name: 'BauxContratEditBail',
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    echeancier: {
      type: Object,
      required: true,
    },
  },
  components: {
    informationsGenerales,
    contrat,
    bailleur,
    informationsFinanciere,
    echeance,
    indexation,
    commentaire,
    piecesJointes,
    contrepartie,
    renouvellementBail,
  },
};
</script>

<style scoped>

</style>
